module.exports = __webpack_public_path__ + "static/media/Eco Verde Estimating - login.8014e457.jpg";